function getListElementPlacement(el, container) {
  var containerTop = container.scrollTop;
  var elTop = el.offsetTop;
  var containerBottom = container.scrollTop + container.offsetHeight;
  var elBottom = el.offsetTop + el.offsetHeight;
  return {
    visible: containerTop <= elTop && containerBottom >= elBottom,
    top: containerTop > elTop
  };
}

export default getListElementPlacement;